import { getTranslateByKey } from "@/main/services/utils";

import * as S from "./styles";
import KogInputPercentageControlled from "@/main/components/shared/inputPercentage/inputPercentage";
import { Control } from "react-hook-form";

interface IAreaDeadlineAnswerProps {
	min: number;
	max: number;
	control: Control<any, any>;
	customName?: string;
}
function AreaDeadlineAnswerRequote({ min, max, control, customName = "deadlineAnswer" }: IAreaDeadlineAnswerProps) {
	const title = getTranslateByKey("quote.requoteDeadlineAnswer");

	return (
		<S.Container>
			<S.Headerpart>
				<S.HeaderTitle>{title}</S.HeaderTitle>
			</S.Headerpart>

			<div>
				<KogInputPercentageControlled
					idScreen="id-requote"
					label={""}
					forceMin={false}
					name={customName}
					required={true}
					control={control}
					customInputProps={{}}
					configRange={{
						rangeNumbers: {
							min: min,
							max: max,
						},
					}}
				/>
			</div>
		</S.Container>
	);
}

export default AreaDeadlineAnswerRequote;
